import React from 'react';
import PropTypes from 'prop-types';
import { List, Image, Checkbox, Button } from 'semantic-ui-react';
import { useTextResources } from '../../language';

import './styles.less';

const WidgetsList = ({ widgets, onToggleWidget, onResetLayouts }) => {
	const text = useTextResources();

	return (
		<>
			<Button onClick={onResetLayouts} style={{ marginBottom: '1.5em' }}>
				<Button.Content visible>Reset Layouts</Button.Content>
			</Button>
			<List verticalAlign='middle' relaxed='very' size='large' divided>
				{widgets.map((widget) => {
					return (
						<List.Item
							disabled={!window.optima.user?.ActionIDs.includes(widget.actionId)}
							className={'list-item'}
							key={widget.id}
							onClick={() => onToggleWidget(widget.id)}
							style={{
								opacity:
									widget.isEnabled &&
									!window.optima.user?.ActionIDs?.includes(widget.actionId)
										? '.3'
										: '1',
							}}
						>
							<Image src={widget.thumbnail} size='tiny' />
							<List.Content>
								<List.Header>{text(widget.title)}</List.Header>
								<List.Description style={{ width: '300px' }}>
									{text(widget.description)}
								</List.Description>
							</List.Content>
							<List.Content
								floated='right'
								verticalAlign='middle'
								style={{ padding: '1em' }}
							>
								<Checkbox
									checked={
										widget.isEnabled &&
										window.optima.user?.ActionIDs.includes(widget.actionId)
									}
								/>
							</List.Content>
						</List.Item>
					);
				})}
			</List>
		</>
	);
};

WidgetsList.propTypes = {
	onToggleWidget: PropTypes.func,
	widgets: PropTypes.array,
	initialWidgets: PropTypes.array,
	onResetLayouts: PropTypes.func,
};

export default WidgetsList;
